import React from 'react';



import {
    formatError,
    login,
    runLogoutTimer,
    saveTokenInLocalStorage,
    saveUserDataInLocalStorage,
    signUp,
} from '../../services/AuthService';
import { toastifyError } from '../../jsx/pages/AlertMsg';


export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';


export function signupAction(email, password, navigate) {
    return (dispatch) => {
        signUp(email, password)
            .then((response) => {
                saveTokenInLocalStorage(response.data);
                runLogoutTimer(
                    dispatch,
                    response.data.expiresIn * 1000,
                );
                dispatch(confirmedSignupAction(response.data));
                navigate('/dashboard');
            })
            .catch((error) => {
                const errorMessage = formatError(error.response.data);
                dispatch(signupFailedAction(errorMessage));
            });
    };
}

export function Logout(navigate) {
   
    sessionStorage.removeItem('UserData');
    navigate('/login');
   

    return {
        type: LOGOUT_ACTION,
    };
}





export function loginAction(username, password, navigate) {
    return (dispatch) => {
        return login(username, password).then((res) => {
            if (res.data?.access_token) {
               
                saveTokenInLocalStorage(res.data.access_token);
                saveUserDataInLocalStorage(res.data);
                
             
                const userData = {
                    ...res.data,
                    requiresOtpVerification: true
                };
                
                dispatch(loginConfirmedAction(userData));
                sessionStorage.setItem('ID', (res.data.ID));
                
                
                navigate('/otp-verify');
                return res;
            } else {
                throw new Error('Invalid response');
            }
        }).catch((error) => {
            console.error(error);
           
            const errorMessage = error.response?.data?.message || 'Invalid Credentials. Please try again.';
            toastifyError(errorMessage);
            dispatch(loginFailedAction(errorMessage));
          
            return Promise.reject(errorMessage);
        });
    };
}




export function loginFailedAction(data) {
    return {
        type: LOGIN_FAILED_ACTION,
        payload: data,
    };
}

export function loginConfirmedAction(data) {
    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload: data,
    };
}

export function confirmedSignupAction(payload) {
    return {
        type: SIGNUP_CONFIRMED_ACTION,
        payload,
    };
}

export function signupFailedAction(message) {
    return {
        type: SIGNUP_FAILED_ACTION,
        payload: message,
    };
}

export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}
